import axios from 'axios';
import '../../common/axiosInterceptor/axios-interceptor';

export const GetMachineOtaLogsAPI = async (machineUDI) => {
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_API_BASE_URL}/admindashboard/api/getMachineOtaLogs`,
    data: {
      machineUDI,
    },
    authRequired: true,
  });
};
